import {
    PETS_CLEAR_VACCINE_RECORD_ERROR,
    PETS_ERROR,
    PETS_SAVE_START,
    PETS_SAVE_SUCCESS,
    PetsAction
} from 'actions/pets/PetsActionsTypes';
import { convertToPet, convertToSavePetDto } from 'actions/pets/PetsConverter';
import { PetDto } from 'actions/pets/PetsDtos';
import { classifyVaccineRecordError } from 'actions/pets/PetsErrors';
import { ApiClient, createTokenConfig } from 'api/ApiClient';
import { serializeToFormData } from 'api/serializer';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Pet, SavePet } from 'types/Pet';

const petsUrl = 'pets';

const errorHandler = (error: unknown): PetsAction => {
    console.error(error);

    return {
        type: PETS_ERROR,
        payload: {
            vaccineRecordError: classifyVaccineRecordError(error)
        }
    };
};

export const clearVaccineRecordError = (): PetsAction => {
    return {
        type: PETS_CLEAR_VACCINE_RECORD_ERROR
    };
};

export const savePetThunk = (
    pet: SavePet
): ThunkAction<Promise<Pet>, RootState, null, RootAction> => {
    return async (dispatch, getState) => {
        try {
            dispatch(savePetStart());

            const marketplaceId = getState().marketplace.data.id;

            const apiMethod = pet.id ? ApiClient.patch : ApiClient.post;
            const url = pet.id ? `${petsUrl}/${pet.id}` : petsUrl;

            const formData = serializeToFormData({
                pet: convertToSavePetDto(pet, marketplaceId)
            });

            const response = await apiMethod<PetDto>(url, formData, createTokenConfig());

            const savedPet = convertToPet(response.data);

            if (!savedPet) {
                throw new Error('Error converting pet');
            }

            dispatch(savePetSuccess(savedPet));

            return savedPet;
        } catch (error) {
            dispatch(errorHandler(error));

            throw error;
        }
    };
};

const savePetStart = (): PetsAction => {
    return {
        type: PETS_SAVE_START
    };
};

const savePetSuccess = (pet: Pet): PetsAction => {
    return {
        type: PETS_SAVE_SUCCESS,
        payload: { pet }
    };
};
